import React from 'react'
import { ClientIcon } from '../components/ClientIcon'
import {
  IconRobot as Bot,
  IconPercentage,
  IconBrain as Brain,
  IconBriefcase as Briefcase,
  IconBuilding as Building,
  IconBuildingSkyscraper as Building2,
  IconCode as Code,
  IconCoffee as Coffee,
  IconDatabase as Database,
  IconFileText as FileText,
  IconWorld as Globe,
  IconHeart as Heart,
  IconPhoto as Image,
  IconMail as Mail,
  IconMessageCircle as MessageSquare,
  IconMusic as Music,
  IconPencil as Pencil,
  IconSearch as Search,
  IconSettings as Settings,
  IconShare as Share2,
  IconShoppingBag as ShoppingBag,
  IconMoodSmile as Smile,
  IconTerminal as Terminal,
  IconUser as User,
  IconVideo as Video,
  IconBolt as Zap,
  IconAlertTriangle,
  IconBook,
  IconBuildingCommunity,
  IconBulb,
  IconCertificate,
  IconChartBar,
  IconChecklist,
  IconDeviceLaptop,
  IconFile,
  IconFolder,
  IconForklift,
  IconHeadset,
  IconPackage,
  IconRosetteDiscountCheck,
  IconRuler2,
  IconSettings2,
  IconShield,
  IconStack2,
  IconTools,
  IconUsers,
} from '@tabler/icons-react'

export const availableIcons = [
  { icon: Bot, name: 'Bot' },
  { icon: Brain, name: 'Brain' },
  { icon: Briefcase, name: 'Briefcase' },
  { icon: Building, name: 'Building' },
  { icon: Building2, name: 'Building2' },
  { icon: Code, name: 'Code' },
  { icon: Coffee, name: 'Coffee' },
  { icon: Database, name: 'Database' },
  { icon: FileText, name: 'Document' },
  { icon: Globe, name: 'Globe' },
  { icon: Heart, name: 'Heart' },
  { icon: Image, name: 'Image' },
  { icon: Mail, name: 'Mail' },
  { icon: MessageSquare, name: 'Message' },
  { icon: Music, name: 'Music' },
  { icon: Pencil, name: 'Pencil' },
  { icon: Search, name: 'Search' },
  { icon: Settings, name: 'Settings' },
  { icon: Share2, name: 'Share' },
  { icon: ShoppingBag, name: 'Shopping' },
  { icon: Smile, name: 'Smile' },
  { icon: Terminal, name: 'Terminal' },
  { icon: User, name: 'User' },
  { icon: Video, name: 'Video' },
  { icon: Zap, name: 'Zap' },
]

// Create a map for quick lookup
export const iconMap = availableIcons.reduce((acc, { icon, name }) => {
  acc[name] = icon
  return acc
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}, {} as Record<string, React.ComponentType<any>>)
iconMap.Percentage = IconPercentage
// Joh icon names (royal-de-vries): a name must be in `iconMap` before its client SVG is used; the Tabler icon is the
// fallback. Kept out of `availableIcons` so other clients' pickers stay the same.
Object.assign(iconMap, {
  Book: IconBook,
  Certificate: IconCertificate,
  Checklist: IconChecklist,
  Page: IconFile,
  Office: IconBuildingCommunity,
  Tools: IconTools,
  Idea: IconBulb,
  Chart: IconChartBar,
  Quality: IconRosetteDiscountCheck,
  Laptop: IconDeviceLaptop,
  Machine: IconForklift,
  Material: IconStack2,
  Product: IconPackage,
  Folder: IconFolder,
  Shield: IconShield,
  Support: IconHeadset,
  Gear: IconSettings2,
  Team: IconUsers,
  Drawing: IconRuler2,
  Warning: IconAlertTriangle,
})

export const getIconByName = (iconName: string | null, size = 16): React.ReactElement | null => {
  if (!iconName) return null
  const IconComponent = iconMap[iconName]
  return IconComponent
    ? React.createElement(ClientIcon, {
        name: iconName,
        group: 'agents',
        size,
        fallback: React.createElement(IconComponent, { size, strokeWidth: 1.75 }),
      })
    : null
}
